/** 联系人导入 API 根路径。 */
export const CONTACT_IMPORT_API_PATH = "/crm/contact-imports";

/** 支持的联系人导入文件后缀。 */
export const CONTACT_IMPORT_ACCEPT = ".xls,.xlsx,.csv";
